import { Theme } from './../index.d';

const UI_THEME_DEFAULT: Theme = {
  pallete: {
    main: '#001030',
    'alternative-main': '#001847',
    'main-light': '#334066',
    'main-alternative-light': '#4d5a80',
    'main-lighter': '#99a3bf',
    'main-alternative-lighter': '#e6e9f2',

    'new-ligther': '#f5f5f5',
    'new-gray': '#4a4a4a',
    'main-new-light': '#fbf9f3',

    secondary: '#C4AB74',
    'alternative-secondary': '#BFA462',
    'alternative-secondary-light': '#D1BA82',
    'secondary-light': '#E4D5AE',
    'secondary-lighter': '#F2EAD2',

    black: '#242424',
    'new-black': '#161616',
    'alternative-dark': '#191919',
    'input-black': '#4c4c4c',
    'alternative-black': '#3b3b3b',
    'light-gray': '#fff8f5',

    'yellow-light': '#FFF3C2',
    dark: '#666666',
    'dark-light': '#7f7f7f',
    gray: '#a4a3a3',
    'alternative-gray': '#929292',
    'gray-light': '#a6a6a6',
    'gray-dark': '#484747',
    light: '#808080',

    'light-purple': '#f4f2f9',

    'secondary-font': "'Proxima Nova', serif",
    'main-font': "'Open Sans', sans-serif",

    purple: '#651fff',
    'lighter-purple': '#e0d2ff',
    'lighter-alternative-purple': '#d5cce7',
    'alternative-dark-purple': '#6d4dae',

    orange: '#ff911f',

    danger: '#e80606',
    'danger-dark': '#950000',
    'danger-light': '#ef5151',
    'danger-lighter': '#facdcd',

    lighter: '#e5e5e5',
    lightness: '#f8f8f8',
    'pagination-active-background': '#00163a',
    'transparent-gray': '#d6dcd97a',

    'main-dark': '#2680eb',
    'transparent-main-light': '#1191e23d',

    'secondary-dark': '#e8c61c',
    'transparent-secondary-dark': '#ffc73d52',

    white: '#ffffff',
    'transparent-black': '#00000014',
    'alternative-transparent-black': 'rgba(0, 0, 0, 0.4)',

    success: '#00b360',
    'success-light': '#f2fbf7',
    info: '#1976d2',
    'info-dark': '#1565c0',
    'info-light': '#e3f2fd',
    warning: '#e65100',
    'warning-light': '#fff3e0',
    neutral: '#5e5e5e',
    'neutral-light': '#ebebeb',
    'neutral-alt': '#525252',
    'badge-success-text': '#0E6027',
    'badge-success-bg': '#A7F0BA',
    'badge-info-text': '#0043CE',
    'badge-info-bg': '#D0E2FF',
    'badge-draft-text': '#1c21a6',
    'badge-draft-bg': '#cddaff',
    'tag-accent-text': '#9f1853',
    'tag-accent-bg': '#ffd6e8',
    'surface-muted': '#f4f4f4',
    'border-muted': '#d5d5d5',
    'text-muted': '#8d8d8d',
    'table-header-bg': '#e0e0e0',
    'table-border': '#c6c6c6',
    interactive: '#0f62fe',
    backdrop: 'color-mix(in srgb, var(--black) 60%, transparent)',
    'backdrop-heavy': 'color-mix(in srgb, var(--black) 80%, transparent)',
    'backdrop-light': 'color-mix(in srgb, var(--black) 50%, transparent)',
    'border-overlay': 'color-mix(in srgb, var(--black) 10%, transparent)',
    'shadow-sm': 'color-mix(in srgb, var(--black) 5%, transparent)',
    'shadow-md': 'color-mix(in srgb, var(--black) 10%, transparent)',
    'shadow-lg': 'color-mix(in srgb, var(--black) 15%, transparent)',
    'shadow-xl': 'color-mix(in srgb, var(--black) 20%, transparent)',
    'shadow-2xl': 'color-mix(in srgb, var(--black) 30%, transparent)',
    'shadow-main': 'color-mix(in srgb, var(--main) 10%, transparent)',
    'shadow-main-lg': 'color-mix(in srgb, var(--main) 15%, transparent)',

    'font-xxs': '10px',
    'font-xs': '12px',
    'font-sm': '14px',
    'font-md': '16px',
    'font-lg': '18px',
    'font-xl': '24px',
    'font-xxl': '32px',

    logo: 'url("/assets/banvox/logo.png")',
    'logo-horizontal': 'url("/assets/banvox/logo.png")',
    'login-background': 'url("/assets/banvox/login-background.svg")',
  },
  brand: {
    name: 'Banvox',
    company_name: 'Banvox Distribuidora de Títulos e Valores Mobiliários Ltda',
    company_cnpj: '02.671.743/0001-19',
    desc: 'Módulo de cadastro',
    prefix: 'banvox',
    footerText: `Banvox - Todos os direitos reservados ${new Date().getFullYear()}`,
    logoText: 'Banvox',
    logoWidth: 50,
    minWidth: 50,
    logo: '/assets/banvox/logo.png',
    logoHorizontal: '/assets/banvox/logo.png',
    favicon: '/assets/favicon/banvox-favicon.ico',
    simplifiedFund: false,
  },
  api: {
    local: 'https://stage.api.data.banvox.prosperita.io',

    // local: 'http://127.0.0.1:8000',
    // local: 'https://petite-garlics-unite.loca.lt',
    dev: 'https://dev.api.data.banvox.prosperita.io',
    stage: 'https://stage.api.data.banvox.prosperita.io',
    prod: 'https://api.data.banvox.prosperita.io',
    clarity_id: 'fhco559uuk',
    sentry_dsn:
      'https://561c977b8b3148de9e15e4e241b2e6ca@sentry.tools.prosperita.io/25',
  },
};

export default UI_THEME_DEFAULT;
